<div class="-left-pane">
  <h3>Solutions</h3>
  <p>
    Worldpay offers a broad range of API products to suit every kind of business, no matter the size or location. Answer
    a few questions and let us help find what you are looking for.
  </p>
  <span class="-left-pane-link">
    <app-link [to]="'/solution-finder'">Find your solution</app-link>
  </span>
</div>
<div class="-right-pane">
  @if (type === 'tabs') {
  <header-tabs></header-tabs>
  } @if (type === 'no-tabs') {
  <div class="-no-tab-container">
    @for (menu of menuContent.children; track menu) {
    <div>
      <h4>{{ menu.title }}</h4>
      <p>{{ menu.description }}</p>
      @for (link of menu.columnOne; track link) {
      <div>
        <app-link [to]="link.path">{{ link.title }}</app-link>
      </div>
      }
    </div>
    }
  </div>
  }
</div>
